import React from "react";
import { useNavigate } from "react-router-dom";
import TButton from "../../components/tbutton";

const Support = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-full w-full p-10 space-y-10">
      <h1 className="text-[32px] font-[400] optima">Support</h1>
      <div className="flex flex-col items-center justify-center gap-2 pt-5">
        <img src="/images/support.svg" alt="Support" />
        <p className="text-[16px] font-[400] glacial text-center text-gray-400">
          Help us improve weddn by sharing about issues you are having or
          feature suggestions
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <TButton
          className="bg-black text-white w-[305px]"
          onClick={() => navigate("/faqs")}
        >
          READ FAQs
        </TButton>
        <TButton
          className="w-[305px]"
          onClick={() => navigate("/send-a-message")}
        >
          SEND US A MESSAGE
        </TButton>
      </div>
    </div>
  );
};

export default Support;
